import "./App.css";
import React, { useContext } from 'react';

// import { CDBModal } from 'cdbreact';
import Nav from "./component/navBar/Nav";
import "bootstrap/dist/css/bootstrap.min.css";
import GameDetails from "./Views/GameDetailes/GameDetails";
import Home from "./Views/Home/Home";
import {
  BrowserRouter,
  Switch,
  Route,
} from "react-router-dom";
import FavouriteGame from "./component/FavouriteGamePage/FavouriteGame";
import { ToastContainer } from 'react-toastify';
import { BottomNavigation } from "reactjs-bottom-navigation";
import SearchComp from "./component/SearchComponent/SearchComp";
import FilterComp from "./component/FilterComponent/FilterComp";
import Footer from "./component/Footer/Footer";
import Games from "./Views/Games/Games";
import Nav2 from "./component/navBar2/Nav2";
import Contact from "./component/Contact/Contact";
import { I18nContext } from './i18n'; // 🔥 Import Context มาด้วย
import Articles from "./Views/Articles/Articles";
import BottomNav from "./component/BottomNav/BottomNav";
import PromotionCard from "./component/PromotionCard/PromotionCard";
import Carousel from "react-multi-carousel";
import promotionData from "./dataset/promotion.json";


function App() {
  const { t } = useContext(I18nContext); // เรียกใช้ t() ตรงนี้
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  const bottomNavItems = [
    {
      title: "Home",
      onClick: ({ id }) => alert("Home clicked " + id),
      icon: <i className="fa-solid fa-star" style={{ color: "#fff " }}></i>,
      activeIcon: <i className="fa-solid fa-star" style={{ color: "GrayText" }}></i>
    },
    {
      title: "Sport",
      onClick: ({ id }) => alert("Home clicked " + id),
      icon: <i className="fa-solid fa-star" style={{ color: "#fff " }}></i>,
      activeIcon: <i className="fa-solid fa-star" style={{ color: "GrayText" }}></i>
    },
    {
      title: "Bet Slip",
      onClick: ({ id }) => alert("Home clicked " + id),
      icon: <i className="fa-solid fa-star" style={{ color: "#fff " }}></i>,
      activeIcon: <i className="fa-solid fa-star" style={{ color: "GrayText" }}></i>
    },
    {
      title: "Profile",
      onClick: ({ id }) => alert("Home clicked " + id),
      icon: <i className="fa-solid fa-star" style={{ color: "#fff " }}></i>,
      activeIcon: <i className="fa-solid fa-star" style={{ color: "GrayText" }}></i>
    },
  ];

  return (
    <section className="app text-light">
      <BrowserRouter>
        <Nav />
        <Contact />

        <div className="row m-2">
          <div className="col-lg-2 p-0  d-none  d-lg-block">
            {/* <SearchComp /> */}
            <FilterComp />
          </div>
          <div className="col-12 col-lg-10">
            <Carousel responsive={responsive} className="">
              {promotionData.map((ele) => {
                return (
                  <PromotionCard
                    key={ele.id}
                    element={ele}
                  />
                );
              })}
            </Carousel>
            <Nav2 />

            <ToastContainer toastStyle={{ background: 'linear-gradient(to right, #b92b27, #1565c0)' }} position="top-right"
              autoClose={3000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark" />

            <Switch>
              <Route exact path="/">
                <Home />
              </Route>

              <Route path="/games/:category">
                <Games />
              </Route>

              <Route path="/article/id/:id">
                <Articles />
              </Route>

              <Route path="/detailes">
                <GameDetails />
              </Route>

              <Route path="/favouritesGames">
                <FavouriteGame />
              </Route>



            </Switch>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
      <BottomNav />
      {/* <BottomNavigation
        items={bottomNavItems}
        selected={0}
        onItemClick={(item) => console.log(item)}
        activeBgColor="#2c2c2c"
        activeTextColor="GrayText"
        hideOnScroll={true}
        className="custom-bottom-nav d-sm-block d-md-none  d-lg-none"
        style={{ borderTop: "0px", position: "fixed", color: "GrayText", bottom: 0, width: "100%", backgroundColor: "#2c2c2c", zIndex: 10000 }}
      /> */}
    </section>
  );
}
export default App;
